import React from "react";

function Apple(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path
        d="M12.7523 6.34615C13.6953 6.34615 14.8773 5.70534 15.5813 4.85092C16.2188 4.0766 16.6836 2.99523 16.6836 1.91386C16.6836 1.767 16.6703 1.62015 16.6438 1.5C15.5945 1.54005 14.3328 2.20756 13.5758 3.10203C12.9781 3.7829 12.4336 4.85092 12.4336 5.94565C12.4336 6.10585 12.4602 6.26605 12.4734 6.31945C12.5398 6.3328 12.6461 6.34615 12.7523 6.34615ZM9.43203 22.5C10.7203 22.5 11.2914 21.6322 12.8984 21.6322C14.532 21.6322 14.8906 22.4733 16.325 22.4733C17.7328 22.4733 18.6758 21.165 19.5656 19.8833C20.5617 18.4148 20.9734 16.973 21 16.9062C20.907 16.8795 18.2109 15.7715 18.2109 12.6608C18.2109 9.96408 20.3359 8.7492 20.4555 8.65575C19.0477 6.62651 16.9094 6.57311 16.325 6.57311C14.7445 6.57311 13.4563 7.53433 12.6461 7.53433C11.7695 7.53433 10.6141 6.62651 9.24609 6.62651C6.64297 6.62651 4 8.78925 4 12.8744C4 15.411 4.98281 18.0944 6.19141 19.8299C7.22734 21.2985 8.13047 22.5 9.43203 22.5Z"
        fill="black"
      />
    </svg>
  );
}

const MemoApple = React.memo(Apple);
export default MemoApple;
